import JungleProgress from './JungleProgress.vue';
export default JungleProgress;
